import React from 'react';
import { Button as ButtonComponent } from '@material-ui/core';

export const Button: React.SFC<any> = ({ children, ...props }) => (
  <ButtonComponent {...props}>{children}</ButtonComponent>
);
